function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStripe = function SvgStripe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.778 7A7.778 7.778 0 0 0 5 14.778v35a7.778 7.778 0 0 0 7.778 7.778h35a7.778 7.778 0 0 0 7.778-7.778v-35A7.778 7.778 0 0 0 47.778 7h-35Zm14.388 17.496c0-1.343 1.158-1.86 3.077-1.86 2.75 0 6.225.792 8.975 2.204v-8.093c-3.004-1.136-5.972-1.584-8.975-1.584-7.348 0-12.233 3.65-12.233 9.746 0 5.738 5.01 7.46 8.983 8.825 2.609.896 4.77 1.639 4.77 3.263 0 1.584-1.448 2.1-3.475 2.1-3.004 0-6.84-1.17-9.88-2.754v8.196a26.19 26.19 0 0 0 9.88 1.963c7.528 0 12.704-3.547 12.704-9.712-.023-6.36-5.328-8.078-9.36-9.382-2.473-.8-4.466-1.446-4.466-2.912Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgStripe;